import React, { useState } from "react";
import { Formik, Form } from "formik";
import styled, { css } from "styled-components";
import Routes from "routing/Routes";
import { Button, Row } from "components/bootstrap";
import { FormikInput, InputOptionalInfo, Spinner } from "components/common";
import IndexSetSelect from "components/streams/IndexSetSelect";
import useIndexSetsList from "components/indices/hooks/useIndexSetsList";
import SelectedIndexSetAlert from "components/inputs/InputSetupWizard/steps/components/SelectedIndexSetAlert";
import { ButtonCol, RecommendedTooltip } from "./StepWrapper";
const SubHeadline = styled.h4(
  ({ theme }) => css`
    margin-top: ${theme.spacings.md};
    margin-bottom: ${theme.spacings.xs};
  `
);
const IndexSetInfoText = styled.p(
  ({ theme }) => css`
    margin-top: ${theme.spacings.xs};
    margin-bottom: ${theme.spacings.md};
  `
);
const NewIndexSetButton = styled(Button)(
  ({ theme }) => css`
    margin-bottom: ${theme.spacings.md};
  `
);
const CreateStreamForm = ({
  submitForm,
  handleBackClick,
  prevCreatedStream = void 0,
  prevShouldCreateNewPipeline = true
}) => {
  var _a, _b, _c, _d, _e;
  const [indexSetsRefetchInterval, setIndexSetsRefetchInterval] = useState(false);
  const { data: indexSetsData, isSuccess: isIndexSetsSuccess } = useIndexSetsList(
    false,
    indexSetsRefetchInterval,
    true
  );
  const validate = (values) => {
    let errors = {};
    if (!values.title) {
      errors = { ...errors, title: "Title is required" };
    }
    if (!values.index_set_id) {
      errors = { ...errors, index_set_id: "Index set is required" };
    }
    return errors;
  };
  const handleNewIndexSetClick = () => {
    window.open(Routes.SYSTEM.INDEX_SETS.CREATE, "_blank");
    setIndexSetsRefetchInterval(1e4);
  };
  if (!isIndexSetsSuccess || !indexSetsData) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const { indexSets } = indexSetsData;
  const initialFormValues = {
    description: (_a = prevCreatedStream == null ? void 0 : prevCreatedStream.description) != null ? _a : void 0,
    title: (_b = prevCreatedStream == null ? void 0 : prevCreatedStream.title) != null ? _b : void 0,
    index_set_id: (_d = prevCreatedStream == null ? void 0 : prevCreatedStream.index_set_id) != null ? _d : (_c = indexSets == null ? void 0 : indexSets.find((indexSet) => indexSet.default)) == null ? void 0 : _c.id,
    remove_matches_from_default_stream: (_e = prevCreatedStream == null ? void 0 : prevCreatedStream.remove_matches_from_default_stream) != null ? _e : true,
    create_new_pipeline: prevShouldCreateNewPipeline
  };
  return /* @__PURE__ */ React.createElement(Formik, { initialValues: initialFormValues, onSubmit: submitForm, validate }, ({ isValid, isValidating, dirty, values }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(FormikInput, { label: "Title", name: "title", id: "title", help: "A descriptive name of the new stream" }), /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      label: /* @__PURE__ */ React.createElement(React.Fragment, null, "Description ", /* @__PURE__ */ React.createElement(InputOptionalInfo, null)),
      name: "description",
      id: "description",
      help: "What kind of messages are routed into this stream?"
    }
  ), /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      label: /* @__PURE__ */ React.createElement(React.Fragment, null, "Remove matches from \u2018Default Stream\u2019"),
      help: /* @__PURE__ */ React.createElement("span", null, "Don't assign messages that match this stream to the \u2018Default Stream\u2019."),
      name: "remove_matches_from_default_stream",
      id: "remove_matches_from_default_stream",
      type: "checkbox"
    }
  ), /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      label: /* @__PURE__ */ React.createElement(React.Fragment, null, "Create a new pipeline for this stream"),
      name: "create_new_pipeline",
      id: "create_new_pipeline",
      type: "checkbox"
    }
  ), /* @__PURE__ */ React.createElement(SubHeadline, null, "Select Index Set"), /* @__PURE__ */ React.createElement(SelectedIndexSetAlert, { indexSets, selectedIndexSetId: values.index_set_id }), /* @__PURE__ */ React.createElement(IndexSetInfoText, null, "Messages that match this stream will be written to the configured Index Set. Index Sets are used to rationally partition data to allow faster searches.", /* @__PURE__ */ React.createElement("br", null), "We recommend creating a new Index Set for each Input type."), /* @__PURE__ */ React.createElement(RecommendedTooltip, { opened: true, withArrow: true, position: "right", label: "Recommended!" }, /* @__PURE__ */ React.createElement(NewIndexSetButton, { onClick: handleNewIndexSetClick }, "Create a new Index Set")), /* @__PURE__ */ React.createElement(IndexSetSelect, { label: "Select Index Set", indexSets }), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(ButtonCol, { md: 12 }, /* @__PURE__ */ React.createElement(Button, { onClick: handleBackClick }, "Back"), /* @__PURE__ */ React.createElement(
    Button,
    {
      bsStyle: "primary",
      type: "submit",
      disabled: isValidating || !isValid || !dirty && !prevCreatedStream
    },
    "Next"
  )))));
};
export default CreateStreamForm;
